"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _lottieWeb = _interopRequireDefault(require("lottie-web"));
var _default = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      ref: "lavContainer",
      style: _vm.style
    });
  },
  name: 'z-lottie',
  props: {
    options: {
      type: Object,
      required: true
    },
    height: String,
    width: String
  },
  data: function data() {
    return {
      style: {
        width: this.width ? this.width + "px" : '100%',
        height: this.height ? this.height + "px" : '100%',
        overflow: 'hidden',
        margin: '0 auto'
      }
    };
  },
  mounted: function mounted() {
    try {
      this.anim = _lottieWeb.default.loadAnimation({
        container: this.$refs.lavContainer,
        renderer: 'svg',
        loop: this.options.loop !== false,
        autoplay: this.options.autoplay !== false,
        animationData: this.options.animationData,
        path: this.options.path,
        rendererSettings: this.options.rendererSettings
      });
      this.$emit('animCreated', this.anim);
      // eslint-disable-next-line no-empty
    } catch (error) {}
  }
};
exports.default = _default;